import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { GET_STATIONS } from 'store/queries';
import { Spinner } from 'admin-components/components';
import AgentPortalError from 'errors/AgentPortalError';
import { Row, Column } from 'components/shared/Layout';

const GetStationsQuery = ({ children }) => {
  const { loading, error, data } = useQuery(GET_STATIONS);

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }
  if (error) {
    throw new AgentPortalError(error);
  }

  const { stations } = data;

  return children({ stations });
};

GetStationsQuery.propTypes = {
  children: PropTypes.func
};

export default GetStationsQuery;
